import { useApp } from "@/context/AppContext";
import { IMAGES } from "@/data/site";
import { PageHero, SectionHeader } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { Section } from "@/components/Section";
import { FileText, Scale, Landmark, Handshake, Download } from "lucide-react";

const DOC_ICONS = [FileText, Scale, Landmark, Handshake];

export default function Investors() {
  const { t } = useApp();
  const iv = t.investorP;
  return (
    <div>
      <PageHero image={IMAGES.building} eyebrow={iv.eyebrow} title={iv.title} subtitle={iv.sub}>
        <a href="/contact" className="oj-btn-gold" data-testid="investor-contact-btn"><Handshake className="w-4 h-4" /> {iv.desk}</a>
      </PageHero>

      <Section sid="investors.metrics" name="Key Metrics" className="border-b border-teal-900/40 bg-[#E9F5F4]/40">
        <div className="oj-container grid grid-cols-2 lg:grid-cols-4 divide-x divide-teal-900/40">
          {iv.metrics.map(([v, l], i) => (
            <Reveal key={l} delay={i * 0.07} className="py-8 px-4 text-center">
              <div className="text-3xl font-extrabold gold-text font-mono">{v}</div>
              <div className="mt-1 text-xs text-slate-600">{l}</div>
            </Reveal>
          ))}
        </div>
      </Section>

      <Section sid="investors.docs" name="Document Vault" className="oj-section">
        <div className="oj-container">
          <SectionHeader eyebrow={iv.vault} title={iv.docsTitle} />
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {iv.docs.map(([title, desc], i) => {
              const Icon = DOC_ICONS[i];
              return (
                <Reveal key={title} delay={i * 0.08}>
                  <div className="oj-card p-7 flex gap-5 h-full items-start">
                    <div className="grid place-items-center w-12 h-12 rounded-xl bg-teal-500/15 border border-cyan-400/30 shrink-0"><Icon className="w-6 h-6 text-teal-600" /></div>
                    <div className="flex-1">
                      <h4 className="font-bold text-white mb-1.5">{title}</h4>
                      <p className="text-sm text-slate-600 leading-relaxed">{desc}</p>
                      <button className="mt-3 inline-flex items-center gap-1.5 py-2 text-sm font-semibold text-teal-400 hover:text-amber-300 transition-colors" data-testid={`investor-doc-${i}`}><Download className="w-4 h-4" /> {iv.reqAccess}</button>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </Section>
    </div>
  );
}
